import Swiper from "swiper/bundle";

const buildSwiperSix = (sliderElm, index) => {
  const uniqueClass = `team-swiper-${index}`;
  sliderElm.classList.add(uniqueClass);

  // Select the navigation buttons within this specific slider element
  const nextButton = sliderElm.querySelector(".swiper-button-next");
  const prevButton = sliderElm.querySelector(".swiper-button-prev");

  // Add unique classes to the next and prev buttons
  if (nextButton) {
    nextButton.classList.add(`${uniqueClass}-next`);
  }

  if (prevButton) {
    prevButton.classList.add(`${uniqueClass}-prev`);
  }

  // Create Swiper instance
  const swiperInstance = new Swiper(`.${uniqueClass}`, {
    loop: true,
    speed: 1000,
    allowTouchMove:false,
    autoplay: {
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 3.2,
        spaceBetween: 28,
      },
      1440: {
        slidesPerView: 4.2,
        spaceBetween: 28,
      },
      1500: {
        slidesPerView: 4.3,
        spaceBetween: 28,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: `.${uniqueClass}-next`,
      prevEl: `.${uniqueClass}-prev`,
    },
  });

  // Check if the number of slides is less than slidesPerView at the current breakpoint
  const checkSlides = () => {
    let currentSlidesPerView;
    const { width } = window.screen;

    if (width >= 1500) {
      currentSlidesPerView = 4.3;
    } else if (width >= 1440) {
      currentSlidesPerView = 4.2;
    } else if (width >= 992) {
      currentSlidesPerView = 3.2;
    } else if (width >= 768) {
      currentSlidesPerView = 2.2;
    } else {
      currentSlidesPerView = 1.2;
    }

    // Add or remove the class if the number of slides is less than slidesPerView
    if (swiperInstance.slides.length < currentSlidesPerView) {
      sliderElm.classList.add("less-slides");
    } else {
      sliderElm.classList.remove("less-slides");
    }
  };

  // Initial check
  checkSlides();

  // Re-check on resize
  window.addEventListener("resize", checkSlides);

};


document.addEventListener("DOMContentLoaded", function () {
  // Get all of the swipers on the page
  const teamSwiper = document.querySelectorAll(".team-swiper");

  // Loop over all of the fetched sliders and apply Swiper on each one.
  teamSwiper.forEach((slider, i) => buildSwiperSix(slider, i));
});
